export function getRandomLightColor() {
  const colors = [
    '#FFDDC1', // Light Peach
    '#FFD1DC', // Light Pink
    '#FFECB3', // Light Yellow
    '#D4E157', // Light Lime Green
    '#B3E5FC', // Light Sky Blue
    '#C5CAE9', // Light Lavender
    '#F8BBD0', // Light Rose
    '#FFCCBC', // Light Coral
    '#DCEDC8', // Light Green
    '#E1F5FE', // Very Light Blue
    '#FFF9C4', // Light Lemon
    '#D7CCC8', // Light Beige
  ];

  const randomIndex = Math.floor(Math.random() * colors.length);
  return colors[randomIndex];
}
